import(/* webpackMode: "eager", webpackExports: ["MobileActionsToolbar"] */ "/vercel/path0/components/action-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/content-wrapper/content-left.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/content-wrapper/content-right.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EDBSelect"] */ "/vercel/path0/components/edb-select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Alert","AlertDescription","AlertTitle"] */ "/vercel/path0/components/ui/alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadCrumb","BreadCrumbItem"] */ "/vercel/path0/components/ui/bread-crumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Collapsible","CollapsibleTrigger","CollapsibleContent"] */ "/vercel/path0/components/ui/collapsible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip","TooltipTrigger","TooltipContent"] */ "/vercel/path0/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["fetchWrapper"] */ "/vercel/path0/lib/hooks/fetch-client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
